import useSWRMutation from "swr/mutation";

import { MUTATION_OPTIONS, getJSON } from "@/utils/swr";

const API_URL = `${import.meta.env.VITE_API_HOST}/recaptcha`;
const REGISTER_URL = "https://suite24.emarsys.net/u/register.php";

const recaptcha = getJSON<{}>("", {
  transformUrl: (url: string, payload: { arg: { prefix: string } }) =>
    `${url}?g-recaptcha-response=${payload.arg}`,
});

const register = getJSON<{}>("", {
  transformUrl: (url: string, payload: { arg: { prefix: string } }) =>
    `${url}?${payload.arg}`,
  requestOptions: { mode: "no-cors" },
});

export const useNewsLetterQuery = () => {
  const { trigger: triggerRecaptcha } = useSWRMutation(API_URL, recaptcha, {
    ...MUTATION_OPTIONS,
    throwOnError: true,
  });

  const { trigger: triggerRegister } = useSWRMutation(
    REGISTER_URL,
    register,
    MUTATION_OPTIONS,
  );

  return {
    triggerRecaptcha,
    triggerRegister,
  };
};
